import React, { useEffect, useState } from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';
import { useNavigate, useLocation } from 'react-router-dom';
import useDeviceInfo from '../utils/useDeviceInfo';

const NavBarComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(getIndexFromPathname(location.pathname));
  const { paddingBottom } = useDeviceInfo();

  useEffect(() => {
    setValue(getIndexFromPathname(location.pathname));
  }, [location]);

  function getIndexFromPathname(pathname) {
    switch (pathname) {
      case '/today':
        return 0;
      case '/feed':
        return 1;
      default:
        return 0;
    }
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate('/today');
        break;
      case 1:
        navigate('/feed');
        break;
      default:
        break;
    }
  };

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        borderTop: '1px solid #DDDDDD',
        borderRadius: 0,
        zIndex: 1000,
        paddingBottom: paddingBottom,
      }}
    >
      <BottomNavigation
        value={value}
        onChange={handleChange}
        showLabels={false}
        sx={{ height: 65 }}
      >
        <BottomNavigationAction
          icon={<ForumRoundedIcon />}
          sx={{ color: value === 0 ? 'primary.main' : 'text.disabled' }}
        />
        <BottomNavigationAction
          icon={<PeopleAltRoundedIcon />}
          sx={{ color: value === 1 ? 'primary.main' : 'text.disabled' }}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default NavBarComponent;
